// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","180":"story"}[chunkId] || chunkId) + "-" + {"93":"a60ea32d5adb8e9edd1d","180":"166c1fc1d909519ee18a","837":"547ef3ab6557029fe809"}[chunkId] + ".css";
};